import * as Blockly from "blockly";

export class FieldPlusMinusBase extends Blockly.Field<string> {
  public static SERIALIZABLE = true;
  public override SERIALIZABLE = true;
  protected readonly isPlus: boolean;

  public static override fromJson<T extends FieldPlusMinusBase>(
    this: new (isPlus?: boolean | string) => T,
    options: Blockly.FieldConfig & { isPlus?: boolean | string },
  ): T {
    return new this(options.isPlus ?? true);
  }

  constructor(isPlus: boolean | string = true) {
    const normalized = isPlus === true || isPlus === "true";
    super(normalized ? "+" : "-");
    this.isPlus = normalized;
  }

  protected override doClassValidation_(newValue?: string): string | null {
    return newValue === "+" || newValue === "-" ? newValue : null;
  }

  public override showEditor_(): void {
    const block = this.getSourceBlock();
    if (!block) return;
    if (this.isPlus) {
      (block as unknown as { addInput_?: () => void }).addInput_?.();
    } else {
      (block as unknown as { removeInput_?: () => void }).removeInput_?.();
    }
  }
}
